import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { Modal, Button } from 'antd';
import ImgView from 'components/common/FileController/ImgView';

@inject(({ commonStore }) => ({ 
	popNoticeList: commonStore.popNoticeList, 
}))
@observer
class NoticePop extends Component {
  state = {
    modalOpenList: []
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.popNoticeList !== this.props.popNoticeList && nextProps.popNoticeList.length > 0){
      let vModalOpenList =[];
      for(let i=0;i<nextProps.popNoticeList.length;i++){
        vModalOpenList.push(true);
      }
      // console.log("vModalOpenList", vModalOpenList);
      this.setState({ modalOpenList: vModalOpenList});
    }
  }

  render() {
    const { popNoticeList } = this.props;
    const { modalOpenList } = this.state;
    return (
      <Fragment>
        {popNoticeList.length > 0 &&
          popNoticeList.map((item,idx)=>{
            return(
              <Fragment key={idx}>
                <Modal
                  width={500}
                  style={{ top: 40*idx, left: 40*idx }}
                  title={item.bodTitle}
                  visible={modalOpenList[idx]}
                  // closable={false}
                  onCancel={()=>{
                    modalOpenList.splice(idx, 1, false);
                    this.setState({ modalOpenList: modalOpenList });
                  }}
                  footer={
                    <Button
                      onClick={()=>{
                        modalOpenList.splice(idx, 1, false);
                        this.setState({ modalOpenList: modalOpenList });
                      }}
                    >확인</Button>
                  }
                >
                  {(item.bodAttachedList !== undefined && item.bodAttachedList !== null) &&
                    (item.bodAttachedList.map((itemFile,idx)=>{
                      return(
                        <Fragment key={idx}>
                          <ImgView
                            fileInfo={{
                              fileId: itemFile.fileId,
                              fileName: itemFile.fileName,
                              physicalName: itemFile.physicalName,
                              serverSubPath: itemFile.serverSubPath,
                            }}
                          />
                          {idx !== item.bodAttachedList.length && <br />}
                        </Fragment>
                      );
                    }))
                  }

                  {item.bodContent.split(`\n`).map((content, idx)=>{
                    return (
                      <Fragment key={idx}>
                        {content}
                        {item.bodContent.split(`\n`).length > idx+1 && <br />}
                      </Fragment>
                  )})}
                </Modal>
              </Fragment>
          );
        })}
      </Fragment>
    );
  }

}

export default withRouter(NoticePop);
